import { useQuery } from '@tanstack/react-query';
import { getAdvertisedPromos } from 'utils/api/promosApi';
import { logError } from 'utils/helpers';
import { filterActivePromos } from 'utils/helpers/activePromoHelpers';

type UseAdvertisedPromosOptions = {
  isEnabled?: boolean;
};

const useAdvertisedPromos = ({
  isEnabled = true,
}: UseAdvertisedPromosOptions = {}) => {
  const { data: advertisedPromos, isFetching } = useQuery(
    ['advertised-promos'],
    () => getAdvertisedPromos(),
    {
      cacheTime: 10 * 60 * 1000, // Data remains in cache for 10 minutes
      onError: (error) => {
        logError('Error fetching promos', {
          method: 'fetchPromos',
          error,
        });
      },
      enabled: isEnabled,
    },
  );
  const activePromos = filterActivePromos(advertisedPromos || []);

  return {
    advertisedPromos: activePromos,
    isLoading: isFetching,
  };
};

export default useAdvertisedPromos;
